import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/tentang-kami/view.tsx");
